import { FETCH_ORDER_WITH_DETAILS_SUCCESS, FETCH_ORDER_WITH_DETAILS_REQUEST, FETCH_ORDER_WITH_DETAILS_FAILURE, FETCH_ORDER_WITH_DETAILS_REST } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getOrderWithDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ORDER_WITH_DETAILS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_ORDER_WITH_DETAILS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_ORDER_WITH_DETAILS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_ORDER_WITH_DETAILS_REST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null });
        default:
            return state;
    }
};
export default getOrderWithDetailsReducer;
